/* eslint-disable import/named */
import { FirebaseReducer, isLoaded } from 'react-redux-firebase';
import { Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import DashboardPage from './DashboardPage';
import LoadingPage from '../loading/LoadingPage';
import React from 'react';

interface DashboardEntryProps extends RouteComponentProps {
  profile: FirebaseReducer.Profile;
}

const DashboardEntryPage: React.FC<DashboardEntryProps> = (props) => {
  if (!isLoaded(props.profile)) return <LoadingPage />;
  if ((props.profile as any)?.partnerId === 'Admin') {
    return <Redirect to="/admin-dashboard" />;
  }
  return <DashboardPage {...(props as any)} />;
};

export default connect(({ firebase: { profile } }: any) => ({ profile }))(DashboardEntryPage);
